export { default } from './ErrorPage.component';
